import { evaluate } from 'mathjs';
import Mustache from 'mustache';

import { AmountInterval } from '@cashier/cashier-model';

const amountExist = (amount: string) => amount !== null && amount !== '';
export const prepareFormula = (
  bonusConfiguration: AmountInterval,
  amount: string,
  currency: string | null,
): number | string => {
  const titleFormula = bonusConfiguration.title?.params?.formula;
  const descriptionFormula = bonusConfiguration.description?.params?.formula;

  const formulaTemplate = currency ? descriptionFormula : titleFormula;

  if (!formulaTemplate || !amountExist(amount)) {
    return '';
  }

  if (
    formulaTemplate.includes('reward.to') &&
    bonusConfiguration.reward?.to == null
  ) {
    return '';
  }

  const formula = Mustache.render(formulaTemplate, {
    ...bonusConfiguration,
    amount: Number(amount) || 0,
    currency,
  });

  try {
    const result = evaluate(formula);

    if (!Number.isFinite(result)) {
      return '';
    }

    return Number(result.toFixed(2));
  } catch {
    return '';
  }
};
